export enum ApiMethodKeys {
  GET = "get",
  PUT = "put",
  POST = "post",
  PATCH = "patch",
  DELETE = "delete",
  OPTIONS = "options",
}
